import script from "./ClassicPhoneCodeStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicPhoneCodeStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicPhoneCodeStep.vue?vue&type=style&index=0&id=5ee6eb10&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee6eb10"]])

export default __exports__